import VehicleCertificate from 'src/@carketa/vehicle_dialog/components/views/vehicle_sales_packet/VehicleCertificateWeb';

type VehicleCertificateSectionProps = {
  vehicle: any;
  vehicle_inspections: any;
};

const VehicleCertificateSection = ({
  vehicle,
  vehicle_inspections,
}: VehicleCertificateSectionProps) => {
  return (
    <div id="vehicle-certificate" className="mt-2 mb-5 w-full">
      <div style={{ overflowX: 'auto' }}>
        <VehicleCertificate
          vehicle={vehicle}
          vehicle_inspections={vehicle_inspections}
        />
      </div>
    </div>
  );
};

export default VehicleCertificateSection;
